/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodexIcon = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8.738 2.382a5.088 5.088 0 0 1 2.538-.346c1.11.128 2.102.6 2.97 1.416a.096.096 0 0 0 .09.025c1.173-.289 2.301-.187 3.383.304l.053.026.128.063c1.13.586 1.942 1.475 2.432 2.665a4.69 4.69 0 0 1 .351 1.772c.017.457-.034.915-.15 1.358a.142.142 0 0 0 .033.13 4.985 4.985 0 0 1 1.316 2.41c.32 1.583-.01 3.01-.987 4.281l-.151.184a5.054 5.054 0 0 1-2.445 1.543.134.134 0 0 0-.09.085c-.213.613-.426 1.136-.823 1.66-.999 1.317-2.468 2.051-4.123 2.042-1.319-.007-2.488-.489-3.508-1.446a.122.122 0 0 0-.117-.028c-.431.14-.867.16-1.337.155a4.936 4.936 0 0 1-2.162-.519A5.05 5.05 0 0 1 4.35 18.68c-.169-.224-.336-.436-.459-.685a6.455 6.455 0 0 1-.412-1.07 5.09 5.09 0 0 1-.014-2.552.14.14 0 0 0 .006-.061.097.097 0 0 0-.03-.054 4.966 4.966 0 0 1-1.15-1.835 4.331 4.331 0 0 1-.278-1.324A5.762 5.762 0 0 1 2.17 9.32c.375-1.236 1.09-2.206 2.147-2.91.235-.156.459-.278.669-.365.238-.1.477-.184.717-.254a.108.108 0 0 0 .046-.026.108.108 0 0 0 .026-.046 5.015 5.015 0 0 1 .921-1.794 5.031 5.031 0 0 1 2.042-1.544zm3.868 11.741a.708.708 0 0 0 0 1.412h4.04a.707.707 0 0 0 0-1.413zM7.64 8.592a.708.708 0 0 0-.8 1.033l1.413 2.47-1.408 2.374a.708.708 0 0 0 1.217.72l1.616-2.727a.708.708 0 0 0 .006-.712L8.068 8.923a.707.707 0 0 0-.428-.331z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCodexIcon as CodexIcon };
